var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/images/bg.jpg"),"alt":""}}),_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":""}}),_c('div',{staticClass:"sloter"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }